/** Rows per page for the coverage training list. */
export const PAGE_SIZE = 20;

/** Categorical palette led by the dashboard teal, muted so it reads as designed. */
export const PALETTE = [
  "#3f88a5", "#e0a458", "#5aa17a", "#8b7bc7",
  "#d6748a", "#6bb6d6", "#8b98a8",
];

/**
 * Returns the palette color for a series index, wrapping when the index runs past the
 * palette so the donut and its table always agree on a type's color.
 * @param {number} i - series index
 * @returns {string} hex color
 */
export const colorAt = (i) => PALETTE[i % PALETTE.length];

/**
 * Formats an ISO date string ("2025-08-01") as a human-readable date ("1 Aug 2025").
 * The Y-M-D parts are read from the string and rendered as a local date, so the day
 * can't drift a day earlier for users in negative-offset timezones (which is what
 * `new Date("2025-08-01")` — parsed as UTC midnight — would cause). Empty values render
 * as an em dash; anything that isn't a date passes through unchanged.
 * @param {string} value - ISO date string
 * @returns {string}
 */
export const formatDate = (value) => {
  if (!value) return "—";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return value;
  const [, year, month, day] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};
